export const MAX_POST_TITLE_CHARACTER_COUNT = 17
export const MAX_COMMENT_CHARACTER_COUNT = 300
export const MAX_REPLY_CHARACTER_COUNT = 130
export const MAX_POST_CHARACTER_COUNT = 500 // todo POST EditorState라 복잡
export const MAX_DDAY_CHARACTER_COUNT = 15

// * 13글자로 제한해야, 삭제 모달에서도 깔끔하게 한 줄로 들어감.
export const MAX_TIMER_NAME_CHARACTER_COUNT = 13
export const MAX_APPOINT_NAME_CHARACTER_COUNT = 8
export const MAX_NICKNAME_CHARACTER_COUNT = 8
